import ApiService from "./ApiService";
import authService from "../AuthService";
import { baseURLManagement } from "../../axios";
import { PANEL_TYPE } from "../../helpers/Constants";

const MAX_PROVIDER_PAGES = 50;

class ProfileApiService extends ApiService {
  /**
   *
   * @returns {Promise}
   */
  async me() {
    try {
      const { data } = await this.axios.get("auth/me");
      authService.updateUserData(data);
      return data;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  async allManagedProviders() {
    const providers = [];
    let page = 1;
    let lastPage = 1;

    do {
      const res = await this.axios.get(`providers`, {
        baseURL: baseURLManagement,
        params: { panel_type: PANEL_TYPE, page },
      });

      const data = res.data || [];
      providers.push(
        ...data.map((provider) => ({
          ...provider,
          name: provider.name || provider.persian_name || provider.english_name,
        }))
      );

      lastPage = (res.additional && res.additional.paginator.last_page) || 1;
      page += 1;
    } while (page <= lastPage && page <= MAX_PROVIDER_PAGES);

    return providers;
  }

  /**
   *
   * @returns {Promise}
   */
  async managedProviders() {
    if (authService.privileged)
      try {
        return await this.allManagedProviders();
      } catch (err) {
        return this.throwFetchError(err);
      }

    try {
      const res = await this.axios.get(
        `providers/employees/${authService.id}/shops`
      );
      return res.data;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }
}

const profileApiService = new ProfileApiService();
export default profileApiService;
